'use client';
import TraegerIcon from '@repo/ui/src/components/Icons/TraegerIcon';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

const NavbarBrand = () => {
  const { geo } = useCurrentUrl();

  return (
    <Anchor link={geo?.isDefault ? '/' : geo?.geoLoc}>
      <TraegerIcon className="text-white h-9" />
      <span className="sr-only">Traeger Home</span>
    </Anchor>
  );
};

export default NavbarBrand;
